import React from "react";

export default function CustomeDurationLabel({ duration, duration_type }) {
  return (
    <>
      {duration}&nbsp;{" "}
      {duration_type == 1
        ? "Hour"
        : duration_type == 2
          ? "Days"
          : duration_type == 3
            ? "Weeks"
            : duration_type == 4
              ? "Months"
              : ""}
    </>
  );
}
